import { render, staticRenderFns } from "./VError404.vue?vue&type=template&id=47931078&scoped=true&lang=pug"
import script from "./VError404.vue?vue&type=script&lang=ts"
export * from "./VError404.vue?vue&type=script&lang=ts"
import style0 from "./VError404.vue?vue&type=style&index=0&id=47931078&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47931078",
  null
  
)

export default component.exports